module.exports = __webpack_public_path__ + "static/media/ic_google_play.5f7baf69.svg";